import { createApp } from 'vue';
import axios from 'axios';
import ReportTable from '../components/reports/ReportTable.vue';
import vueUIInitiator from '../../../modules/vue-ui-initiator';
import StarRate from '../../../vue-components/StarRate';

vueUIInitiator('js--star-rate', StarRate, 'star-rate');

document.addEventListener('DOMContentLoaded', () => {
    const reportParent = document.getElementById('reportApp');
    if (reportParent) {
        createApp({
            components: { ReportTable },
            data () {
                return {
                    url: '/api/public/content/mortgage/reports/weeklyreport/', // prod and test
                    allCreditors: [], // общее состояние кредиторов (после первого запроса)
                    allCreditorsCur: [], // текущее состояние кредиторов (учитывая поиск)
                    allRegions: [], // общее состояние кредиторов (после первого запроса)
                    allRegionsCur: [], // текущее состояние кредиторов (учитывая поиск)
                    isThrottleStart: false, // переключатель тротлинга
                    throttleTimer: 800, // таймер тротлинга
                    dates: [], // все даты
                    allColumns: [], // все столбцы таблицы
                    tableData: [], // заголовки таблицы
                    showArr: [], // массив раскрытых элементов в таблице
                    activeTab: 'creditor', // переключатель по кредиторам / регионам
                    regionName: 'Выберите регион',
                    columnName: 'Выдано кредитов, шт.',
                    columnId: 5,
                    filterState: {
                        opened: '',
                        list: ['date', 'creditor', 'region'],
                        date: {
                            active: false,
                            highlight: false,
                            curVal: '',
                            prevVal: '',
                        },
                        creditor: {
                            active: false,
                            highlight: false,
                            curVal: '',
                            inputVal: ''
                        },
                        region: {
                            active: false,
                            highlight: false,
                            curVal: '',
                            inputVal: ''
                        },
                    },
                    weekName: '',
                    openSelect: '',
                    showContent: true,
                    searchCreditor: '', // состояние поиска в выпадашке кредиторов
                    searchRegion: '', // состояние поиска в выпадашке регионов
                    activateTab: false, // активация выпадашки на мобилке (табы)
                    activateColumn: false, // активация выпадашки на мобилке (имя колонки)
                    params: {}, // get-параметры для запроса
                    isLoad: false,
                    isFirstStart: true
                };
            },
            computed: {
                tabName() {
                    return this.activeTab === 'creditor' ? 'Статистика по кредиторам' : 'Статистика по регионам';
                },
                prevDate() {
                    const curVal = this.filterState.date.curVal;
                    const curValIdx = this.dates.findIndex(item => item === curVal);

                    if (curValIdx === (this.dates.length -1)) {
                        return '';
                    }

                    return this.dates[curValIdx + 1];
                }
            },
            mounted() {
                this.getApiData(true);
            },
            methods: {
                // задержка, чтобы запросы делались раз в throttleTimer милисекунд
                throttle(fn, params) {
                    if (this.isThrottleStart) return;
                    this.isThrottleStart = true;

                    setTimeout(() => {
                        this.isThrottleStart = false;
                        fn(...params);
                    }, this.throttleTimer);
                },
                getExcelDoc() {
                    let params = {
                        type: 'psm',
                        format: 'xlsx',
                        summaryType: 'weekly',
                        reportType: this.activeTab,
                    };
                    this.filterState.list.forEach((key) => {
                        if (this.filterState[key].curVal) {
                            params[key] = this.filterState[key].curVal;
                        }
                    });
                    const query = new URLSearchParams(params).toString();
                    window.open(`${this.url}?${query}`);
                },
                getApiData(fetchFilters) {
                    this.showContent = false;
                    this.showArr = [];
                    this.isLoad = true;

                    axios.get(this.url, {
                        params: {
                            type: 'psm',
                            summaryType: 'weekly',
                            ...this.params
                        }
                    })
                        .then(response => {
                            const resp = response.data;
                            this.showContent = true;

                            if (fetchFilters) {
                                this.allCreditors = resp.creditors;
                                this.allCreditorsCur = resp.creditors;
                                this.dates = resp.dates;
                                this.allRegions = resp.regions;
                                this.allRegionsCur = resp.regions;
                                this.filterState.date.curVal = resp.dates[0];
                                this.params.reportType = this.activeTab;
                                this.params.date = resp.dates[0];
                                this.getApiData();
                                this.isLoad = false;
                                return;
                            }

                            this.tableData = resp;
                            this.params = {};

                        })
                        .catch(error => {
                            console.error(error)
                            this.isLoad = false;
                        })
                        .finally(() => {
                            this.$nextTick(() => {
                                if (this.isFirstStart) {
                                    setTimeout(() => {
                                        this.isFirstStart = false;
                                    }, 4000)
                                }
                                this.isLoad = false;
                            });
                        })
                },
                toggleShowArray(data) {
                    this.$refs.table.setCurActiveId(data);
                },
                // переключение табов
                handlerTab(tabName) {
                    this.activeTab = tabName;
                    this.params.reportType = this.activeTab;
                    this.resetAllFilters();
                    this.collectAndSendFilters();
                },
                // выбор чего-то в фильтре
                handlerFilter(item, type, notGetData) {
                    this.filterState[type].active = false;
                    this.filterState[type].highlight = true;
                    this.filterState[type].curVal = item;

                    if (!notGetData) {
                        this.collectAndSendFilters();
                    }
                    if (this.activeTab === type) {
                        this.toggleShowArray(item);
                    }
                },
                // собирает все фильтры и отправляет запрос
                collectAndSendFilters() {
                    this.filterState.list.forEach((key) => {
                        if (this.filterState[key].curVal) {
                            this.params[key] = this.filterState[key].curVal;
                        }
                    });
                    this.params.reportType = this.activeTab;

                    this.getApiData();
                },
                // сброс фильтров по нажатию крестика
                resetFilter(type, varName, isSend) {
                    this.filterState[type].curVal = '';
                    this.filterState[type].inputVal = '';
                    this.showArr = [];
                    this.handlerSearch(type, varName);

                    if (isSend) {
                        this.collectAndSendFilters();
                    }

                    if (this.getWindowWidth() < 1124) {
                        this.isLoad = true;
                        setTimeout(() => {
                            this.changeColumn(this.columnName);
                            this.isLoad = false;
                        }, 1000);
                    }
                },
                // проходимся по фильтрам и закрываем открытые
                closeFilters() {
                    this.filterState.list.forEach(key => this.filterState[key].active = false);
                    this.activateColumn = false;
                    this.activateTab = false;
                },
                handlerSelect(data) {
                    const curState = this.filterState[data].active;
                    this.closeFilters();
                    this.filterState[data].active = !curState;
                    document.addEventListener('click', this.outsideClick);
                },
                // поиск внутри выпадашек фильтра
                handlerSearch(type, varName) {
                    const regExp = new RegExp(this.filterState[type].inputVal, 'i');

                    this[`${varName}Cur`] = this[varName].filter((item) => {
                        return regExp.test(item);
                    });
                },
                resetAllFilters() {
                    this.resetFilter('region', 'allRegions', false);
                    this.resetFilter('creditor', 'allCreditors', false);
                    this.handlerFilter(this.dates[0], 'date', true);
                    this.activateTab = false;
                    this.activateColumn = false;
                },
                getWindowWidth() {
                    return document.documentElement.clientWidth;
                },
                changeColumn(item, idx) {
                    this.columnName = item;
                    this.columnId = idx;
                    this.activateColumn = false;
                },
                switchMobileFilter(varName) {
                    this[varName] = !this[varName];
                    document.addEventListener('click', this.outsideClick);
                },
                outsideClick(e) {
                    const refsArr = ['filterTab', 'filterDate', 'filterCred', 'filterReg', 'filterCol'];
                    let isFiltersClick = false;

                    refsArr.forEach((item) => {
                        if (e.target === this.$refs[item] || this.$refs[item].contains(e.target)) {
                            isFiltersClick = true;
                        }
                    });

                    if (!isFiltersClick) {
                        this.closeFilters();
                        document.removeEventListener('click', this.outsideClick);
                    }
                },
                datePlusOneDay(weekBefore) {
                    if (!weekBefore) return '';

                    const curDate = weekBefore.replace(/(\d\d)\.(\d\d)\./g, '$2/$1/');
                    const curDateObj = new Date(curDate);
                    curDateObj.setDate(curDateObj.getDate() + 1);

                    return curDateObj.toLocaleDateString('ru-RU');
                }
            }
        }).mount(reportParent);
    }
});